// extracted by mini-css-extract-plugin
export default {"fileContainer":"Files_fileContainer__c4v5t"};